<template>
  <HeaderHome :user="$store.state.user.prenom" />
  <div class="background">
    <div class="panel">

      <!-- En-tête -->
      <div class="panel-header">
        <div class="panel-header-left">
          <div>
            <p class="panel-label">Gestion</p>
            <h2 class="panel-title">Paiements supprimés</h2>
          </div>
        </div>
        <div class="search-wrap">
          <svg class="search-icon" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
          </svg>
          <input
            class="search-input"
            v-model="filters['global'].value"
            placeholder="Rechercher..."
          />
        </div>
      </div>

      <!-- Tableau -->
      <div class="table-wrap">
        <DataTable
          :value="paiements"
          :rows="10"
          v-model:filters="filters"
          filterDisplay="menu"
          :loading="loading"
          :rowsPerPageOptions="[10, 20, 50]"
          v-model:selection="selectedItem"
          selectionMode="single"
          responsiveLayout="scroll"
          :paginator="true"
          :globalFilterFields="['Eleve', 'Description', 'Mode de Paiement', 'Totalamount', 'DatedePaiement']"
          dataKey="id"
          tableStyle="width:100%"
        >
          <Column field="Eleve" header="Élève" :sortable="true" style="min-width:8rem">
            <template #filter="{ filterModel, filterCallback }">
              <input
                type="text"
                v-model="filterModel.value"
                @keydown.enter="filterCallback()"
                class="p-column-filter"
                placeholder="Filtrer par élève"
              />
            </template>
          </Column>
          <Column header="Description" style="min-width:10rem">
            <template #body="slotProps">{{ slotProps.data.Description }}</template>
          </Column>
          <Column header="Mode" style="min-width:8rem">
            <template #body="slotProps">{{ slotProps.data["Mode de Paiement"] }}</template>
          </Column>
          <Column header="Montant total" style="min-width:8rem">
            <template #body="slotProps">{{ slotProps.data.Totalamount }}</template>
          </Column>
          <Column header="Date de paiement" style="min-width:10rem">
            <template #body="slotProps">{{ slotProps.data["Date de Paiement"].date }}</template>
          </Column>
        </DataTable>
      </div>

    </div>
  </div>
</template>

<script>
import HeaderHome from "@/components/home/HeaderHome.vue";
import { FilterMatchMode } from "primevue/api";

export default {
  name: "OtherPaiementDeleted",

  components: {
    HeaderHome,
  },

  data() {
    return {
      paiements: [],
      selectedItem: null,
      loading: false,
      filters: {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      },
    };
  },

  mounted() {
    this.getOtherPaiementDeleted();
  },

  methods: {
    getOtherPaiementDeleted() {
      window.api
        .get("/otherpaiement/deleted", {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
        })
        .then((response) => {
          this.paiements = response.data.OtherPaiements;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>

/* ── Page ── */
.background {
  min-height: 100vh;
  background: #f4f6f9;
  display: flex;
  padding: 24px;
  box-sizing: border-box;
}

/* ── Panneau ── */
.panel {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: hidden;
}

/* ── En-tête ── */
.panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 22px;
  border-bottom: 1px solid #e2e8f0;
  gap: 16px;
  flex-wrap: wrap;
}

.panel-header-left {
  display: flex;
  align-items: center;
  gap: 14px;
}

.logo {
  width: 44px;
  height: 44px;
  object-fit: contain;
  cursor: pointer;
  flex-shrink: 0;
}

.panel-label {
  margin: 0;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #94a3b8;
  text-align: left;
}

.panel-title {
  margin: 2px 0 0;
  font-size: 17px;
  font-weight: 700;
  color: #1e293b;
  text-align: left;
}

/* ── Recherche ── */
.search-wrap {
  position: relative;
  display: flex;
  align-items: center;
}

.search-icon {
  position: absolute;
  left: 10px;
  color: #94a3b8;
  pointer-events: none;
}

.search-input {
  padding: 8px 12px 8px 34px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  font-size: 13px;
  color: #1e293b;
  background: #f8fafc;
  outline: none;
  width: 220px;
  transition: border-color 0.18s, background 0.18s;
}

.search-input:focus {
  border-color: #3b82f6;
  background: #ffffff;
}

.search-input::placeholder {
  color: #cbd5e1;
}

/* ── Tableau ── */
.table-wrap {
  padding: 16px;
  flex: 1;
  overflow: auto;
}

:deep(.p-datatable .p-datatable-thead > tr > th) {
  background: #f8fafc;
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 1px solid #e2e8f0;
  padding: 10px 14px;
}

:deep(.p-datatable .p-datatable-tbody > tr > td) {
  font-size: 13px;
  color: #334155;
  padding: 10px 14px;
  border-bottom: 1px solid #f1f5f9;
}

:deep(.p-datatable .p-datatable-tbody > tr:hover) {
  background: #f0f7ff !important;
  cursor: pointer;
}

:deep(.p-datatable .p-datatable-tbody > tr.p-highlight) {
  background: #eff6ff !important;
  color: #1d4ed8;
}

:deep(.p-paginator) {
  background: transparent;
  border: none;
  padding: 8px 0 4px;
  font-size: 13px;
}

</style>
